export interface CompanyFormOption {
  value: string
  label?: string
  labelKey?: string
}

export const companyTypeOptions: CompanyFormOption[] = [
  {
    value: 'soleProprietorship',
    labelKey: 'frontend:company.companyTypeSoleProprietorship',
  },
  {
    value: 'companyUnderCivilLaw',
    labelKey: 'frontend:company.companyTypeCivilLaw',
  },
  {
    value: 'registeredMerchant',
    labelKey: 'frontend:company.companyTypeRegisteredMerchant',
  },
  {
    value: 'openTradingCompany',
    labelKey: 'frontend:company.companyTypeOpenTrading',
  },
  {
    value: 'limitedPartnership',
    labelKey: 'frontend:company.companyTypeLimitedPartnership',
  },
  {
    value: 'limitedLiabilityCompanyGmbh',
    labelKey: 'frontend:company.companyTypeGmbh',
  },
  {
    value: 'limitedLiabilityCompanyUG',
    labelKey: 'frontend:company.companyTypeUg',
  },
  {
    value: 'publicCompany',
    labelKey: 'frontend:company.companyTypePublicCompany',
  },
  {
    value: 'limitedLiabilityPartnership',
    labelKey: 'frontend:company.companyTypeGmbhCoKg',
  },
  {
    value: 'partnershipCompany',
    labelKey: 'frontend:company.companyTypePartnership',
  },
  {
    value: 'trustFoundation',
    labelKey: 'frontend:company.companyTypeTrustFoundation',
  },
  {
    value: 'legalFoundation',
    labelKey: 'frontend:company.companyTypeLegalFoundation',
  },
  {
    value: 'privatePerson',
    labelKey: 'frontend:company.companyTypePrivatePerson',
  },
]

export const profitDeterminationTypeOptions: CompanyFormOption[] = [
  { value: 'balance', labelKey: 'frontend:company.profitDeterminationBalance' },
  {
    value: 'revenueSurplusStatement',
    labelKey: 'frontend:company.profitDeterminationEur',
  },
  { value: 'none', labelKey: 'frontend:company.profitDeterminationNone' },
]

export const incomeRegistrationPeriodOptions: CompanyFormOption[] = [
  { value: 'monthly', labelKey: 'frontend:company.periodMonthly' },
  { value: 'quarterly', labelKey: 'frontend:company.periodQuarterly' },
  { value: 'annually', labelKey: 'frontend:company.periodAnnually' },
  { value: 'unknown', labelKey: 'frontend:company.unknown' },
]

export const chartOfAccountsOptions: CompanyFormOption[] = [
  { value: 'skr03', label: 'SKR03' },
  { value: 'skr04', label: 'SKR04' },
  { value: 'skr45', label: 'SKR45' },
  { value: 'other', labelKey: 'frontend:company.chartOfAccountsOther' },
  { value: 'unknown', labelKey: 'frontend:company.unknown' },
]
